<article
	class="reservation-card"
	[class.is-expanded]="expanded()"
	[attr.data-status]="reservation().status"
	[attr.aria-expanded]="expanded()"
	role="button"
	tabindex="0"
	(click)="toggled.emit()"
	(keydown.enter)="toggleFromKeyboard($event)"
	(keydown.space)="toggleFromKeyboard($event)"
>
	<div class="reservation-time">
		@if (showsServiceDate()) {
			<strong>{{ formatServiceDate(reservation().serviceDate) }}</strong>
			<span>{{ formatTimeRange() }}</span>
		} @else {
			<strong>{{ formatTime(reservation().startsAt) }}</strong>
			<span>έως {{ formatTime(reservation().endsAt) }}</span>
		}
	</div>
	<div class="reservation-main">
		<div class="reservation-title">
			<h2>
				<span>{{ reservation().customerName || 'Walk-in πελάτης' }}</span>
				<small>· #{{ reservation().code }}</small>
			</h2>
			<span class="status" [attr.data-status]="reservation().status">
				{{ statusLabel(reservation().status) }}
			</span>
		</div>
		<div class="reservation-meta">
			<div>
				<span class="icon icon--users" aria-hidden="true"></span>
				<b>{{ reservation().partySize }}</b> ·
				{{ sourceLabel(reservation().source) }}
			</div>
			<div>
				<span class="icon icon--utensils" aria-hidden="true"></span>
				{{ reservation().areaName }} · {{ reservation().tableName }}
			</div>
			<!-- <span>{{ sourceLabel(reservation().source) }}</span> -->
			@if (reservation().customerPhone) {
				<div>
					<span class="icon icon--phone" aria-hidden="true"></span>
					<a
						[href]="'tel:' + reservation().customerPhone"
						(click)="$event.stopPropagation()"
					>
						{{ reservation().customerPhone }}
					</a>
				</div>
			}
		</div>
		@if (reservation().customerNotes || reservation().operatorNotes) {
			<div class="notes">
				@if (reservation().customerNotes) {
					<span>Πελάτης: {{ reservation().customerNotes }}</span>
				}
				@if (reservation().operatorNotes) {
					<span>Ομάδα: {{ reservation().operatorNotes }}</span>
				}
			</div>
		}
	</div>
	<div class="reservation-actions">
		@for (action of statusActions(reservation().status); track action.status) {
			<button
				type="button"
				[attr.aria-label]="statusLabel(action.status)"
				[class.action-primary]="
					action.status === 'booked' ||
					action.status === 'arrived' ||
					action.status === 'completed'
				"
				[class.action-danger]="action.status === 'cancelled'"
				[disabled]="saving()"
				(click)="
					$event.stopPropagation(); transitionRequested.emit(action.status)
				"
			>
				<span [class]="'icon icon--' + action.icon" aria-hidden="true"></span>
			</button>
		}
		@if (
			reservation().status !== 'cancelled' && reservation().status !== 'expired'
		) {
			<button
				type="button"
				aria-label="Επεξεργασία"
				(click)="$event.stopPropagation(); editRequested.emit()"
			>
				<span class="icon icon--pencil" aria-hidden="true"></span>
			</button>
		}
	</div>
</article>
